<template>
  <div>
    <v-row>
      <v-col class="mb-0">
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.status') }}
        </h6>
        <span
          class="body-2"
          :class="{ 'primary--text': data.enabled }"
          v-if="!data.suspended"
        >
          {{ data.enabled ? $t('host.label.active') : $t('host.label.blocked') }}
        </span>
        <span class="warning--text body-2" v-else>
          {{ $t('host.label.suspended') }}
        </span>
      </v-col>
      <v-col class="mb-0">
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.isFavorite') }}
        </h6>
        <div class="d-flex align-center">
          <v-icon v-if="data.starred" color="yellow darken-2" small>mdi-star</v-icon>
          <v-icon v-else color="grey lighten-2" small>mdi-star-outline</v-icon>
          <span class="d-block body-2 ml-1">
            {{ $t(`host.label.${data.starred}`) }}
          </span>
        </div>
      </v-col>
      <v-col class="mb-0">
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.isMonitored') }}
        </h6>
        <div class="d-flex align-center">
          <v-icon v-if="data.monitored" color="primary" small>mdi-account-eye</v-icon>
          <v-icon v-else color="grey lighten-2" small>mdi-account-eye-outline</v-icon>
          <span class="d-block body-2 ml-1">
            {{ $t(`host.label.${data.monitored}`) }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="data.suspended && data.suspension">
      <v-col>
        <v-alert color="yellow lighten-4" class="warning--text">
          <v-row no-gutters>
            <v-col>
              <h6 class="text-uppercase">Suspenso em</h6>
            </v-col>
            <v-col>
              <h6 class="text-uppercase">Suspenso por</h6>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <span class="body-2">
                {{formatDateWithoutTime(data.suspension.date)}}
              </span>
            </v-col>
            <v-col>
              <span class="body-2">
                {{data.suspension.suspended_by.name}}
              </span>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-4">
            <v-col>
              <h6 class="text-uppercase">Motivo</h6>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <span class="body-2">
                {{$t(`host.suspensionTypes.${data.suspension.type}`)}}
              </span>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-4">
            <v-col>
              <h6 class="text-uppercase">Comentário</h6>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <span class="body-2">
                {{data.suspension.notes ? data.suspension.notes : '---'}}
              </span>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="mb-0">
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.asaasAccount')  }}
        </h6>
        <div class="d-flex align-center">
          <span class="d-block">
            <span
              :class="{ linked: data.asaas_account }"
              :style="`background-image: url(${logoAsaas}`"
              :alt="data.asaas_account ? $t('host.label.asaasLinked') : $t('host.label.asaasNotLinked')"
              class="asaas small"
            />
          </span>
          <span class="d-block body-2">
            {{ data.asaas_account ? $t('host.label.asaasLinked') : $t('host.label.asaasNotLinked')}}
          </span>
        </div>
      </v-col>
      <!-- Não vem a informação do pertencimento do Host ao Checklist em seus detalhes -->
      <!-- <v-col class="mb-0">
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.checklistAccount')  }}
        </h6>
        <div class="d-flex align-center">
          <span
            :class="{ linked: data.checklist_id }"
            :style="`background-image: url(${logoChecklist}`"
            :alt="data.checklist_id ? $t('customer.label.checklistLinked') : $t('customer.label.checklistNotLinked')"
            class="asaas"
          />
          <span class="body-2">
            {{ data.checklist_id ? $t('host.label.checklistLinked') : $t('host.label.checklistNotLinked')}}
          </span>
        </div>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { catalogDateWithoutTime } from '@/util/catalog'

import logoAsaas from '@/assets/images/logo-asaas.svg'
import logoChecklist from '@/assets/images/logo-hauseful-checklist.svg'

export default {
  name: 'HostStatus',

  props: {
    data: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      logoAsaas,
      logoChecklist,
      formatDateWithoutTime: catalogDateWithoutTime,
    }
  }
}
</script>

<style>
.asaas.small {
  width: 15px;
  height: 15px;
  background-size: 14px;
  background-position: center 0px;
}

.asaas.small.linked {
  background-position: center -24px;
}
</style>
